import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ganadoressorteosoportunos',
  templateUrl: './ganadoressorteosoportunos.component.html',
  styleUrls: ['./ganadoressorteosoportunos.component.scss']
})
export class GanadoressorteosoportunosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
